import React from 'react'
import {Field} from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";


const GeneralForm = ({ element }) => (

    <div>
        <Field type="text" name="acronym" customlabel="Acronyme" component={CustomInputTextComponent} required/>
        <Field type="text" name="name" customlabel="Nom du régime" component={CustomInputTextComponent} required/>
        <Field type="text" name="geslab_id" customlabel="ID Geslab" component={CustomInputTextComponent} required/>
    </div>


)

export default GeneralForm